import React from "react";
import GetInvolved from "../Components/AboutPageComponents/GetInvolved";
import VolunteerForm from "../Components/VolunteerForm";

function Involved() {
  return (
    <>
      <GetInvolved />
      <VolunteerForm />
    </>
  );
}

export default Involved;
